import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const TABLET_BREAKPOINT = 1024;
const COMPACT_BREAKPOINT = 1200;
const CHATBOT_WIDTH = 384; // w-96 = 24rem = 384px

// Access global chatbot state without hooks
const getChatbotState = () => {
  // Look for chatbot element in DOM as fallback
  const chatbotElement = document.querySelector('[data-testid="chatbot-sidebar"]') 
    || document.querySelector('.fixed.right-0.w-96'); // matches Layout.tsx structure
  return chatbotElement !== null;
};

export function useTableResponsive() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined,
  );
  const [isTablet, setIsTablet] = React.useState<boolean | undefined>(
    undefined,
  );
  const [isCompact, setIsCompact] = React.useState<boolean | undefined>(
    undefined,
  );

  React.useEffect(() => {
    const updateResponsive = () => {
      let width = window.innerWidth;
      
      // Check if chatbot is open by looking at DOM
      const isChatbotOpen = getChatbotState();
      
      // Subtract chatbot width if open and not mobile
      if (isChatbotOpen && width >= MOBILE_BREAKPOINT) {
        width -= CHATBOT_WIDTH;
      }
      
      const newIsMobile = width < MOBILE_BREAKPOINT;
      const newIsTablet = width >= MOBILE_BREAKPOINT &&
        width < TABLET_BREAKPOINT;
      const newIsCompact = width < COMPACT_BREAKPOINT;

      setIsMobile(newIsMobile);
      setIsTablet(newIsTablet);
      setIsCompact(newIsCompact);
    };

    const mql = window.matchMedia(`(max-width: ${COMPACT_BREAKPOINT - 1}px)`);
    mql.addEventListener("change", updateResponsive);

    // Watch for DOM changes to detect chatbot open/close
    const observer = new MutationObserver(() => {
      updateResponsive();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    updateResponsive();

    return () => {
      mql.removeEventListener("change", updateResponsive);
      observer.disconnect();
    };
  }, []);

  return {
    isMobile: !!isMobile,
    isTablet: !!isTablet,
    isDesktop: !isMobile && !isTablet,
    isCompact: !!isCompact,
  };
}

